
import {defineComponent, reactive} from "vue";
import {Toast} from "vant";
import request from "@/utils/request"
export default defineComponent({
  name: "renBaoPsychologicalActivity",
  setup() {
    const state = reactive({
      show: false,
      actions: [
        {name: '立即呼叫（加密）', tel: ''},
      ]
    })
    // 咨询加密账号
    const gotoConsult = async ()=>{
      let res = await request.get('/api/healthc/virtualNumber/getVirtualNumber');
      if (res.code === 0) {
        state.show = true
        state.actions[0].tel = res.data
      } else {
        Toast.fail(res.message);
      }
    }
    const toTel = (tel) => {
      state.show = false
      tel = 'tel:' + tel
      location.href = tel
    }
    return{
      toTel,
      gotoConsult,
      state
    }
  }
})
